import { invertErrorCodes } from '@myre/common-core';

/**
 * AUTO-GENERATED by tools/ci/error-codes.ts — do not edit by hand.
 * Run `bun tools/ci/error-codes.ts new <block> <ClassName>` to reserve a code,
 * then `bun tools/ci/error-codes.ts sync`.
 *
 * Every error code @myre/app-user-domain declares in a registered block, mapped to
 * the class holding it. A code is retired, never renumbered and never reused: it
 * ships on the wire and is persisted in exported reports. See docs/error-codes.md.
 */
export const RESERVED_ERROR_CODES = {
  // block 8 (8000-8999) — user — user
  8002: 'UserNotFoundError',
  8003: 'LoginAttemptFailedError',
  8004: 'NoEmailAddressSuppliedError',
  // block 9 (9000-9999) — user — user
  9001: 'MissingRegisterInformationError',
  9002: 'EmailAlreadyUsedError',
  9003: 'RoleNotFoundError',
  9004: 'CustomerNotFoundError',
  9005: 'InvalidToken',
  9006: 'PasswordLengthError',
  9007: 'TermsAndConditionsError',
  9008: 'TokenIsNull',
  9009: 'TokenNotExist',
  9010: 'UserMissing',
  9014: 'UserDoesNotBelongToCustomerError',
  9015: 'UserAlreadyActiveError',
  9016: 'UserToPromoteIsAlreadyPowerUserError',
  9017: 'AlreadyAssociatedUserError',
  9018: 'AlreadyInvitedUserError',
  9019: 'UserInvitationNotFoundError',
  9021: 'CannotInvalidateApiKeyError',
  9022: 'TwoFactorAuthenticationRequiredError',
  9023: 'TwoFactorAuthenticationFailedError',
  9024: 'PasswordCompareError',
  9025: 'UserToDissociateIsPowerUserError',
  9026: 'UnrecognizedApplicationError',
  9027: 'UserAlreadyHasAccessToApp',
  9028: 'UserDoesNotHaveAccessToApp',
  9029: 'AlreadyAssociatedUserAppError',
  9030: 'CurrentPasswordCompareError',
  9031: 'MissingFileError',
  9032: 'UnknownSsoProviderError',
  9033: 'NoPartnerFoundError',
  9035: 'GdprError',
  9036: 'ExternalUserInvitationError',
  9038: 'InvalidInvitationId',
  9039: 'InvalidInvitationAccept',
  9040: 'SsoProviderError',
  9041: 'MissingCustomerError',
  9044: 'WrongFileTypeError',
  // block 145 (145000-145999) — user — customer
  145001: 'CustomerSlugError',
  145002: 'CustomerSlugAlreadyUsedError',
} as const satisfies Record<number, string>;

/** Codes whose class is gone. Kept so the allocator never hands them out again. */
export const RETIRED_ERROR_CODES = [] as const satisfies readonly number[];

/** Name -> code, for consumers branching on a code they do not declare. */
export const ERROR_CODE = invertErrorCodes(RESERVED_ERROR_CODES);
